import { render, staticRenderFns } from "./base-popup.vue?vue&type=template&id=785cc870&scoped=true&"
import script from "./base-popup.vue?vue&type=script&lang=js&"
export * from "./base-popup.vue?vue&type=script&lang=js&"
import style0 from "./base-popup.vue?vue&type=style&index=0&id=785cc870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785cc870",
  null
  
)

export default component.exports